import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';

export const USER_ROUTES: Routes = [
  {
    path: 'roles',
    canActivate: [ScopeGuard],
    data: { scopes: [SCOPES.admin.roles.manage] },
    loadChildren: () => import('../roles/roles.routes').then((m) => m.ROLES_ROUTES),
  },
  {
    path: ':id',
    loadComponent: () => import('./components/user-view/user-view.component').then((m) => m.UserViewComponent),
    children: [
      {
        path: 'bookings',
        loadComponent: () =>
          import('./components/user-view/user-bookings/user-bookings.component').then((m) => m.UserBookingsComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.bookings.read] },
      },
      {
        path: 'enrolment',
        loadComponent: () =>
          import('./components/user-view/user-enrolment/user-enrolment.component').then(
            (m) => m.UserEnrolmentComponent
          ),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.enrolment.read] },
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./components/user-view/user-events/user-events.component').then((m) => m.UserEventsComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.events.read] },
      },
      {
        path: 'logs',
        loadComponent: () =>
          import('./components/user-view/user-logs/user-logs.component').then((m) => m.UserLogsComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.securityLog.view] },
      },
      {
        path: 'members',
        loadComponent: () =>
          import('./components/user-view/user-members/user-members.component').then((m) => m.UserMembersComponent),
      },
      {
        path: 'opportunities',
        loadComponent: () =>
          import('./components/user-view/user-opportunities/user-opportunties.component').then(
            (m) => m.UserOpportunitiesComponent
          ),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.opportunities.read] },
      },
      {
        path: 'pmr',
        loadComponent: () =>
          import('./components/user-view/user-pmr/user-pilot-master-record.component').then(
            (m) => m.UserPilotMasterRecordComponent
          ),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.events.read] },
      },
      {
        path: 'sales',
        loadComponent: () =>
          import('./components/user-view/user-sales/user-sales.component').then((m) => m.UserSalesComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.sales.view] },
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./components/user-view/user-security/user-security.component').then((m) => m.UserSecurityComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./components/user-view/user-settings/user-settings.component').then((m) => m.UserSettingsComponent),
      },
      {
        path: '',
        loadComponent: () =>
          import('./components/user-view/user-overview/user-overview.component').then((m) => m.UserOverviewComponent),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./components/user-list/user-list.component').then((m) => m.UserListComponent),
  },
];
